
    import React from 'react';
    import { useRssFeedCreate, useRssFeedSoftDelete,useRssFeedMultipleSoftDelete, useRssFeedUpdate } from '../../queries/RssFeed.queries';
    import RssFeed from './RssFeed';
    
    const RssFeedContainer = () => {
    
      const {mutate:addRecord} = useRssFeedCreate();
      const {mutate:editRecord} = useRssFeedUpdate();
      const {mutate:deleteRecord} = useRssFeedSoftDelete();
      const {mutate:deleteRecords} = useRssFeedMultipleSoftDelete();
    
      const onAddRecord = (record) => {
        return new Promise((resolve,reject) => {
          addRecord(record, {
            onSuccess: async () => resolve('Record created successfully.'),
            onError: async (error) => reject(error?.message),
          });
        })
      };
    
      const onEditRecord = (record) => {
        return new Promise((resolve, reject) => {
          editRecord(
            record,
            {
              onSuccess: async () => resolve('Record updated successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
    
      const onDeleteRecord = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecord(
            record, 
            {
              onSuccess: async () => resolve('Record deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      const onMultiDelete = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecords(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      return (
        <RssFeed 
          addRecord={onAddRecord}
          deleteRecord={onDeleteRecord}
          deleteRecords={onMultiDelete}
          editRecord={onEditRecord}
        />
      )
    }
    
    export default RssFeedContainer;
    